import { useMemo } from "react";
import classNames from "classnames";
import CiroModal from "../../../components/shared/CiroModal";
import CiroButton, { CiroButtonStyleEnum } from "../../../components/shared/CiroButton";
import CiroTextArea from "../../shared/CiroTextArea";

interface IBulkCompanyEntryModal {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  companiesText: string;
  setCompaniesText: (text: string) => void;
}

const BulkCompanyEntryModal = ({
  isOpen,
  onClose,
  onSave,
  companiesText,
  setCompaniesText,
}: IBulkCompanyEntryModal) => {
  const companyCount = useMemo(() => {
    return companiesText
      .split("\n")
      .map(company => company.trim())
      .filter(Boolean)
      .length;
  }, [companiesText]);

  const handleSave = () => {
    onSave();
    onClose();
  };

  return (
    <CiroModal isOpen={isOpen} onClose={onClose} size="LARGE">
      <div className={classNames("flex", "flex-col", "gap-4")}>
        <h2 className={classNames("text-xl", "font-semibold")}>
          Bulk add companies
        </h2>
        <p className={classNames("text-sm", "text-gray-500")}>
          Enter one company per line. You can paste a list of companies from a
          spreadsheet or document.
        </p>
        <CiroTextArea
          customClassName={classNames("min-h-20")}
          value={companiesText}
          onChange={(e) => setCompaniesText(e.target.value)}
          placeholder={`Microsoft
Google 
Apple`}
        />
        <div
          className={classNames(
            "flex",
            "flex-row",
            "justify-end",
            "gap-2",
            "mt-2",
          )}
        >
          <CiroButton
            style={CiroButtonStyleEnum.PRIMARY}
            onClick={onClose}
            analyticsField={"Cancel bulk add companies in curated search"}
          >
            Cancel
          </CiroButton>
          <CiroButton
            analyticsField={"Confirm bulk add companies in curated search"}
            style={CiroButtonStyleEnum.LOUD}
            onClick={handleSave}
          >
            {companyCount > 0 ? `Add ${companyCount} ${companyCount === 1 ? "company" : "companies"}` : 'Update companies'}
          </CiroButton>
        </div>
      </div>
    </CiroModal>
  );
};

export default BulkCompanyEntryModal;
